import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import "../auth.css";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

interface Props {
  onSuccess(): void;
}

export default function AdminLogin({ onSuccess }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setError(null);

    if (!email || !password) {
      setError("Enter email and password.");
      return;
    }

    try {
      setLoading(true);

      const form = new FormData();
      form.append("email", email);
      form.append("password", password);

      const res = await axios.post(`${API}/admin/login`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("role", "admin");

      onSuccess();
    } catch (e: any) {
      const msg =
        e?.response?.data?.detail ||
        "Invalid credentials or server error";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="auth-page animated-bg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <motion.div
        className="register-shell"
        initial={{ scale: 0.95, y: 30 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {/* LEFT */}
        <div className="register-left">
          <h1>Admin Login</h1>
          <p>Restricted access — administrators only</p>
        </div>

        {/* RIGHT */}
        <div className="register-right">
          <div className="field">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label>Email address</label>
          </div>

          <div className="field">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label>Password</label>
          </div>

          {error && <div className="auth-error">{error}</div>}

          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={submit}
            disabled={loading}
          >
            {loading ? "Signing in…" : "Sign in"}
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
}
